import React, { useRef, useState, useContext } from "react";
import useIntersectionObserver from "../../hooks/useIntersectionObserver";
import GalleryComponent from "./GalleryComponent";
import "../../style.css";

const Gallery = ({ slug }) => {
  const sectionRef = useRef(null);
  const [contentLoaded, setContentLoaded] = useState(false);

  const handleIntersection = () => {
    setContentLoaded(true);
  };

  const isVisible = useIntersectionObserver(sectionRef, handleIntersection);

  return (
    <div
      ref={sectionRef}
      className={`loading-container${
        contentLoaded ? "" : " loading-spinner-container"
      }`}
    >
      {contentLoaded ? (
        <section
          className={`gallery${isVisible ? " fade-in-observer" : ""}`}
          id="gallery"
        >
          <GalleryComponent key={slug} slug={slug} />
        </section>
      ) : (
        <div className="observer_spinner"></div>
      )}
    </div>
  );
};

export default Gallery;
